/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as EmergencyRouteImport } from './routes/emergency'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WeeksWeekIdRouteImport } from './routes/weeks.$weekId'

const LaunchRoute = LaunchRouteImport.update({
  id: '/launch',
  path: '/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const EmergencyRoute = EmergencyRouteImport.update({
  id: '/emergency',
  path: '/emergency',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WeeksWeekIdRoute = WeeksWeekIdRouteImport.update({
  id: '/weeks/$weekId',
  path: '/weeks/$weekId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/emergency': typeof EmergencyRoute
  '/launch': typeof LaunchRoute
  '/weeks/$weekId': typeof WeeksWeekIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/emergency': typeof EmergencyRoute
  '/launch': typeof LaunchRoute
  '/weeks/$weekId': typeof WeeksWeekIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/emergency': typeof EmergencyRoute
  '/launch': typeof LaunchRoute
  '/weeks/$weekId': typeof WeeksWeekIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/emergency' | '/launch' | '/weeks/$weekId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/emergency' | '/launch' | '/weeks/$weekId'
  id: '__root__' | '/' | '/emergency' | '/launch' | '/weeks/$weekId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EmergencyRoute: typeof EmergencyRoute
  LaunchRoute: typeof LaunchRoute
  WeeksWeekIdRoute: typeof WeeksWeekIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/launch': {
      id: '/launch'
      path: '/launch'
      fullPath: '/launch'
      preLoaderRoute: typeof LaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emergency': {
      id: '/emergency'
      path: '/emergency'
      fullPath: '/emergency'
      preLoaderRoute: typeof EmergencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weeks/$weekId': {
      id: '/weeks/$weekId'
      path: '/weeks/$weekId'
      fullPath: '/weeks/$weekId'
      preLoaderRoute: typeof WeeksWeekIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EmergencyRoute: EmergencyRoute,
  LaunchRoute: LaunchRoute,
  WeeksWeekIdRoute: WeeksWeekIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
